export default {
  formSubmitHost: 'https://contact.apps-api.instantpage.dev-secureserver.net',
  generateUrlHost: 'https://url-generator.apps.dev-secureserver.net',
  contactsHost: 'https://contacts.dev-godaddy.com',
  conversationsWebHost: 'https://conversations.dev-godaddy.com'
};
